import { siteInfo } from "@/mocks/profile";
import HeroSection from "./components/HeroSection";
import ProfileSection from "./components/ProfileSection";
import FeaturedWorks from "./components/FeaturedWorks";
import LatestNews from "./components/LatestNews";
import GalleryPreview from "./components/GalleryPreview";
import FanDiscussion from "./components/FanDiscussion";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: siteInfo.name,
  url: siteInfo.url,
  description: siteInfo.description,
  potentialAction: {
    "@type": "SearchAction",
    target: `${siteInfo.url}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: siteInfo.name,
  url: siteInfo.url,
  description: siteInfo.description,
  foundingDate: siteInfo.foundingYear,
};

export default function Home() {
  return (
    <>
      <title>{`${siteInfo.name} | ${siteInfo.slogan}`}</title>
      <meta name="description" content={siteInfo.description} />
      <meta name="keywords" content={siteInfo.keywords} />
      <link rel="canonical" href={siteInfo.url} />
      <meta property="og:title" content={`${siteInfo.name} | ${siteInfo.slogan}`} />
      <meta property="og:description" content={siteInfo.description} />
      <meta property="og:url" content={siteInfo.url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteInfo.name} />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${siteInfo.name} | ${siteInfo.slogan}`} />
      <meta name="twitter:description" content={siteInfo.description} />
      <script type="application/ld+json">
        {JSON.stringify(homeJsonLd)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(orgJsonLd)}
      </script>

      <main>
        <HeroSection />
        <ProfileSection />
        <FeaturedWorks />
        <LatestNews />
        <GalleryPreview />
        <FanDiscussion />
      </main>
    </>
  );
}